import styled from 'styled-components';

import { flexCenter, flexStart } from '../../../style/reusableStyle';

export const ViewJobContainerStyled = styled.div`
  margin: 18px 0px 200px;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.white};
  max-width: 1000px;
  & .contents {
    margin-left: 30px;
  }
  & .heading {
    margin-bottom: 30px;
    ${flexStart};
    gap: 50px;
  }
`;

export const InfoRow = styled.div`
  width: 100%;
  ${flexStart};
  gap: 10px;
  margin-bottom: 20px;
  & .title {
    width: 150px;
    color: ${({ theme }) => theme.colors.darkText};
    flex-shrink: 0;
  }
  & .value {
    ${flexCenter(8)};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    & .title {
      font-weight: 600;
    }
  }
`;

export const ActionsContainer = styled.div`
  ${flexStart};
  gap: 24px;
  margin-top: 20px;
`;
